import { useSearchParams } from "react-router-dom";
import ForeCasterInfo from "../../../../components/AssetManagement/Overview/PerformanceForecaster/ForeCasterInfo/ForeCasterInfo";
import FloatingActionItems from "../../../FloatingItems/FloatingActionItems";

const ForeCasterInfoScreen = () => {
  const [searchParams] = useSearchParams();

  return (
    <>
      <ForeCasterInfo />
      <div data-tracker="398">
        <FloatingActionItems
          selectedSiteFloatingAction={
            searchParams.get("selectedSite") as string
          }
          selectedDimensionsFloatingAction={""}
          trackIdFloatingAction={"428"}
        />
      </div>
    </>
  );
};

export default ForeCasterInfoScreen;
